<template>
  <Layout>
    <PageHeaderV2 class="page-header" :title="title" :sub-title="subtitle">
      <template #afterTitle>
        <McButton
          variant="secondary"
          class="ms-3"
          :text="$t('global.back')"
          icon="icon-outline_arrow-left"
          @click="$router.replace({ name: 'Master Home Page' })"
        />
      </template>
    </PageHeaderV2>
    <b-card
      v-if="hasAccessCustomerContract && hasAccessVms"
      class="mc-card"
    >
      <b-tabs lazy content-class="p-4">
        <b-tab
          :active="selectedTab === 'customer'"
          @click="changeTab('customer')"
        >
          <template #title>
            {{ $t('global.field.customer') }}
          </template>
          <CustomerContractPage />
        </b-tab>
        <b-tab
          :active="selectedTab === 'vendor'"
          @click="changeTab('vendor')"
        >
          <template #title>
            {{ 'Vendor' }}
          </template>
          <VendorContractPage />
        </b-tab>
      </b-tabs>
    </b-card>
    <template v-else-if="hasAccessCustomerContract">
      <CustomerContractPage />
    </template>
    <template v-else-if="hasAccessVms">
      <VendorContractPage />
    </template>
  </Layout>
</template>
<script>
import appConfig from '@/app.config'
import Layout from '@/router/layouts/main'
import { mapGetters } from 'vuex'

import PageHeaderV2 from '@/components/page-header-v2'
import McButton from '@/components/McButton'

import VendorContractPage from '@/router/views/master/vendor-contract'
import CustomerContractPage from '@/router/views/master/contract/customer-contract'


export default {
  page: {
    title: 'Contract',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeaderV2,
    McButton,
    VendorContractPage,
    CustomerContractPage,
  },
  data() {
    return {
      selectedTab: 'customer'
    }
  },
  computed: {
    ...mapGetters({
      hasAccessAll: 'identity/hasAccessAll',
    }),
    title() {
      return this.$t('master.list.contract.title')
    },
    subtitle() {
      return this.$t('master.list.contract.list')
    },
    hasAccessCustomerContract() {
      return this.hasAccessAll([
        "tms-customer-contract:create",
        "tms-customer-contract:delete",
        "tms-customer-contract:read",
        "tms-customer-contract:update",
      ])
    },
    hasAccessVms() {
      return this.hasAccessAll([
        "vms:create",
        "vms:delete",
        "vms:read",
        "vms:update",
      ])
    }
  },
  created() {
    // Set initial tab based on query parameter
    const type = this.$route.query.type
    if (type === 'vendor' && this.hasAccessVms) {
      this.selectedTab = 'vendor'
    } else if (type === 'customer' && this.hasAccessCustomerContract) {
      this.selectedTab = 'customer'
    } else {
      this.selectedTab = this.hasAccessCustomerContract ? 'customer' : 'vendor'
    }
  },
  methods: {
    changeTab(value) {
      this.selectedTab = value
      
      this.$router.replace({
        query: {
          ...this.$route.query,
          type: value
        }
      })
    },
  },
}
</script>